<template>
	<VueCustomTooltip :label="title" multiline position="is-top" v-bind="$attrs" class="inline-block">
		<slot></slot>
	</VueCustomTooltip>
</template>

<script lang="ts">
import VueCustomTooltip from "@adamdehaven/vue-custom-tooltip";
import { defineComponent } from "vue";

export default defineComponent({
	name: "BaseTooltp",
	components: {
		VueCustomTooltip,
	},
	props: {
		title: {
			type: String,
			default: "tooltip",
		},
	},
});
</script>

<style lang="css">
:root {
	--vue-custom-tooltip-color: #fff;
	--vue-custom-tooltip-background: rgba(82, 84, 96, 0.9);
	--vue-custom-tooltip-border-radius: 5px;
	--vue-custom-tooltip-font-weight: 400;
}
</style>
